import { Link } from "gatsby"
import styled from 'styled-components'
import bullet from './right-tri-blue.png'

const StyledLink = styled(Link)`
 font-weight: bold;
 text-decoration: none;
 color: #3479ae;
 margin-right: 30px;

 &:hover {
    opacity: 0.8;
  }

 &::after {
    width: 12px;
    height: 12px;
    display: inline-block;
    position: relative;
    content: " ";
    background-image: url('${bullet}');
    background-size: cover;
    background-position: center;
    left: 8px;
    top: 2px;
 }


`
export default StyledLink

